import * as React from 'react';
import cls from 'classnames';

import SubheaderLinks from '../subheader';
import { SubheaderLinksProps } from '../subheader/SubHeader';
import HeaderAccountMenu from './HeaderAccountMenu';
import { HeaderContext, HeaderContextMenus } from './HeaderContext';
import { FLAG_ROOM_BLOCK_RECOMMENDATIONS_ENABLED } from '@weddingspot/ws-api-client';

import styles from './Header.module.scss';
const { SUBHEADER_LINKS } = HeaderContextMenus;

export interface HeaderRightLinksAuthBaseProps extends SubheaderLinksProps {
    userFirstName: string;
    unreadMessageCount: number;
    unreadReviewsCount: number;
}

interface HeaderRightLinksAuthProps extends HeaderRightLinksAuthBaseProps {
    renderMenuItems: () => React.ReactNode;
}

// Main links component for auth'd users
const HeaderRightLinksAuth: React.SFC<HeaderRightLinksAuthProps> = (props) => {
    const { headerItemClicked, isContextMenuOpen, openContextMenu, closeContextMenu } = React.useContext(HeaderContext);

    return (
        <div className={cls(styles.navWrapper, styles.hiddenMobile)} data-testid='HeaderRightLinks'>
            {FLAG_ROOM_BLOCK_RECOMMENDATIONS_ENABLED && (
                <a
                    href='/hotels/'
                    target='_blank'
                    className={styles.navLink}
                    onClick={() => {
                        headerItemClicked('Hotel Room Blocks');
                    }}
                >
                    Hotel Room Blocks
                </a>
            )}
            <div
                className={styles.navLink}
                onClick={() => {
                    headerItemClicked('Browse Venues');
                    isContextMenuOpen(SUBHEADER_LINKS) ? closeContextMenu(SUBHEADER_LINKS) : openContextMenu(SUBHEADER_LINKS);
                }}
            >
                Browse Venues
            </div>
            <a href='/blog/' target='_blank' className={styles.navLink} onClick={() => headerItemClicked('Blog')}>
                Blog
            </a>
            <div className={styles.authNavWrapper}>
                <HeaderAccountMenu userFirstName={props.userFirstName} unreadTotalCount={props.unreadMessageCount + props.unreadReviewsCount}>
                    {props.renderMenuItems()}
                </HeaderAccountMenu>
            </div>
            <div
                className={cls(styles.subheaderLinksWrapper, { [styles.subheaderLinksWrapperShowing]: isContextMenuOpen(SUBHEADER_LINKS) })}
                data-testid='SubheaderLinks'
            >
                <SubheaderLinks curMarket={props.curMarket} subheaderLinks={props.subheaderLinks} />
            </div>
        </div>
    );
};

export default HeaderRightLinksAuth;
